export default ['sale', 'rent'];
